import { useState } from 'react'
import { useForm } from 'react-hook-form'
import useQuery from 'hooks/useQuery'
import { filterEmptyValues } from 'utils/helpers'
import { Button, Dropdown } from 'components/common'
import StoreDropdown from 'components/userManagement/storeDropdown'
import { CustomObject } from 'types/common'

// URL query key holding the picker filter object
export const FILTER_FIELD_PICKERS = 'pickerFilters'

const NONE = 'NONE'

type Props = {
  toggleFilterForm: () => void
}

const PickerFilterForm = ({ toggleFilterForm }: Props) => {
  const { getQuery, removeQuery, setMultipleQueries } = useQuery()
  const filters = getQuery(FILTER_FIELD_PICKERS)

  const [resetFilter, setResetFilter] = useState(false)

  const { handleSubmit, setValue, reset } = useForm({
    defaultValues: filters,
  })

  const onFilterApply = (data: CustomObject) => {
    Object.keys(data).forEach((key) => {
      if (data[key] === NONE) delete data[key]
    })

    const filteredData = filterEmptyValues(data)

    if (Object.values(filteredData).length > 0) {
      setMultipleQueries({ [FILTER_FIELD_PICKERS]: filteredData, page: 1 })
    } else {
      removeQuery(FILTER_FIELD_PICKERS)
    }

    toggleFilterForm()
  }

  const cancelFilter = () => {
    reset(filters)
    setResetFilter((pre) => !pre)
    toggleFilterForm()
  }

  return (
    <div className="mt-2 rounded-lg border bg-white px-5 py-3">
      <form onSubmit={handleSubmit(onFilterApply)}>
        <div className="grid grid-cols-2 gap-x-14 gap-y-3 md:grid-cols-3">
          <Dropdown
            name="role"
            label="Role"
            setValue={setValue}
            defaultValue={filters?.role || resetFilter}
            options={[
              { label: '--- NONE ---', value: NONE, disabled: false },
              { label: 'Picker', value: 'PICKER', disabled: false },
              { label: 'Supervisor', value: 'SUPERVISOR', disabled: false },
            ]}
          />

          <Dropdown
            name="isActive"
            label="Status"
            setValue={setValue}
            defaultValue={filters?.isActive || resetFilter}
            options={[
              { label: '--- NONE ---', value: NONE, disabled: false },
              { label: 'Active', value: 'true', disabled: false },
              { label: 'Inactive', value: 'false', disabled: false },
            ]}
          />

          <StoreDropdown
            withNoneOption
            setValue={setValue}
            defaultValue={filters?.store || resetFilter}
            name="store"
            label="Old App Store"
          />
        </div>
        <div className="my-4 flex gap-5">
          <Button buttonText="Apply Filters" className="w-32" />
          <Button
            buttonText="Cancel"
            variant="outline"
            type="button"
            onClick={cancelFilter}
            className="w-32"
          />
        </div>
      </form>
    </div>
  )
}

export default PickerFilterForm
